"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("preact/jsx-runtime");
var compat_1 = require("preact/compat");
var SvgHorizontalMoreOption = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 30 30" }, props, { children: (0, jsx_runtime_1.jsx)("path", { style: {
            fill: '#fff',
            fillOpacity: 1,
            stroke: 'none',
            strokeWidth: 0.5,
            strokeMiterlimit: 4,
            strokeDasharray: 'none',
            strokeOpacity: 1,
        }, d: "M22.002 12.965a2 2 0 0 0-2 2 2 2 0 0 0 2 2 2 2 0 0 0 2-2 2 2 0 0 0-2-2zm-14.004.045a2 2 0 0 0-2 2 2 2 0 0 0 2 2 2 2 0 0 0 2-2 2 2 0 0 0-2-2zm7.002.025a2 2 0 0 0-2 2 2 2 0 0 0 2 2 2 2 0 0 0 2-2 2 2 0 0 0-2-2z" }) }))); };
var Memo = (0, compat_1.memo)(SvgHorizontalMoreOption);
exports.default = Memo;
